/* eslint-disable */

import React, { useState, useEffect } from 'react';

const API_BASE_URL = 'https://crosslisting-backend-aacranbzdyd3ffbd.centralindia-01.azurewebsites.net/api/v1';

const KpiDashboard = () => {
  const [loading, setLoading] = useState(false);
  const [kpiData, setKpiData] = useState({
    totalActions: 0,
    totalErrors: 0,
    totalApiCalls: 0,
    avgPerformance: 0,
    successRate: 0,
    recentActions: [],
    errorLogs: [],
    apiLogs: [],
    performanceLogs: []
  });

  const getAuthToken = () => {
    return localStorage.getItem('token') || localStorage.getItem('accessToken');
  };

  const getHeaders = () => ({
    'Content-Type': 'application/json',
    ...(getAuthToken() && { 'Authorization': `Bearer ${getAuthToken()}` })
  });

  // Fetch data from existing backend endpoints
  const fetchDashboardData = async () => {
    setLoading(true);
    try {
      // Fetch recent action logs (using action/start response pattern)
      // Since no GET endpoint exists, we'll use the data that gets saved when actions happen
      
      // For now, showing data that gets saved via existing POST endpoints
      // You'll need to add GET endpoints in backend to fetch this data
      
      // Mock data structure - this will be replaced when backend GET endpoints are added
      const mockData = {
        totalActions: 0,
        totalErrors: 0,
        totalApiCalls: 0,
        avgPerformance: 0,
        successRate: 0,
        recentActions: [],
        errorLogs: [],
        apiLogs: [],
        performanceLogs: []
      };
      
      setKpiData(mockData);
      
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchDashboardData();
    const interval = setInterval(fetchDashboardData, 30000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div style={{ padding: '20px', background: '#f5f5f5', minHeight: '100vh' }}>
      {/* Header */}
      <div style={{ marginBottom: '30px' }}>
        <h1 style={{ margin: 0, color: '#333' }}>KPI Dashboard</h1>
        <p style={{ color: '#666' }}>Real-time monitoring from database</p>
      </div>

      {/* KPI Cards */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
        gap: '20px',
        marginBottom: '30px'
      }}>
        {/* Total Actions Card */}
        <div style={{
          background: 'white',
          borderRadius: '10px',
          padding: '20px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          borderLeft: '4px solid #2196f3'
        }}>
          <div style={{ fontSize: '14px', color: '#666', marginBottom: '10px' }}>Total Actions</div>
          <div style={{ fontSize: '32px', fontWeight: 'bold', color: '#2196f3' }}>{kpiData.totalActions}</div>
          <div style={{ fontSize: '12px', color: '#4caf50', marginTop: '10px' }}>+12% from last week</div>
        </div>

        {/* Total Errors Card */}
        <div style={{
          background: 'white',
          borderRadius: '10px',
          padding: '20px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          borderLeft: '4px solid #f44336'
        }}>
          <div style={{ fontSize: '14px', color: '#666', marginBottom: '10px' }}>Total Errors</div>
          <div style={{ fontSize: '32px', fontWeight: 'bold', color: '#f44336' }}>{kpiData.totalErrors}</div>
          <div style={{ fontSize: '12px', color: '#4caf50', marginTop: '10px' }}>-5% from last week</div>
        </div>

        {/* API Calls Card */}
        <div style={{
          background: 'white',
          borderRadius: '10px',
          padding: '20px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          borderLeft: '4px solid #9c27b0'
        }}>
          <div style={{ fontSize: '14px', color: '#666', marginBottom: '10px' }}>API Calls</div>
          <div style={{ fontSize: '32px', fontWeight: 'bold', color: '#9c27b0' }}>{kpiData.totalApiCalls}</div>
          <div style={{ fontSize: '12px', color: '#666', marginTop: '10px' }}>Last 30 days</div>
        </div>

        {/* Performance Card */}
        <div style={{
          background: 'white',
          borderRadius: '10px',
          padding: '20px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          borderLeft: '4px solid #ff9800'
        }}>
          <div style={{ fontSize: '14px', color: '#666', marginBottom: '10px' }}>Avg Performance</div>
          <div style={{ fontSize: '32px', fontWeight: 'bold', color: '#ff9800' }}>{kpiData.avgPerformance}ms</div>
          <div style={{ fontSize: '12px', color: '#4caf50', marginTop: '10px' }}>+8% faster</div>
        </div>
      </div>

      {/* Success Rate Card */}
      <div style={{
        background: 'white',
        borderRadius: '10px',
        padding: '20px',
        marginBottom: '30px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <div style={{ fontSize: '14px', color: '#666', marginBottom: '10px' }}>Success Rate</div>
        <div style={{ fontSize: '48px', fontWeight: 'bold', color: '#4caf50' }}>{kpiData.successRate}%</div>
        <div style={{
          width: '100%',
          height: '10px',
          background: '#e0e0e0',
          borderRadius: '5px',
          marginTop: '10px',
          overflow: 'hidden'
        }}>
          <div style={{
            width: `${kpiData.successRate}%`,
            height: '100%',
            background: '#4caf50',
            borderRadius: '5px'
          }}></div>
        </div>
      </div>

      {/* Recent Actions Table */}
      <div style={{
        background: 'white',
        borderRadius: '10px',
        padding: '20px',
        marginBottom: '30px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <h3 style={{ marginTop: 0, marginBottom: '20px' }}>Recent Actions</h3>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: '#f5f5f5', borderBottom: '2px solid #ddd' }}>
                <th style={{ padding: '12px', textAlign: 'left' }}>ID</th>
                <th style={{ padding: '12px', textAlign: 'left' }}>Action Type</th>
                <th style={{ padding: '12px', textAlign: 'left' }}>Status</th>
                <th style={{ padding: '12px', textAlign: 'left' }}>Start Time</th>
                <th style={{ padding: '12px', textAlign: 'left' }}>Duration (ms)</th>
              </tr>
            </thead>
            <tbody>
              {kpiData.recentActions.length === 0 ? (
                <tr>
                  <td colSpan="5" style={{ padding: '40px', textAlign: 'center', color: '#999' }}>
                    No actions found. Start an action using the backend API.
                  </td>
                </tr>
              ) : (
                kpiData.recentActions.map((action) => (
                  <tr key={action.id} style={{ borderBottom: '1px solid #eee' }}>
                    <td style={{ padding: '12px' }}>{action.id}</td>
                    <td style={{ padding: '12px' }}>{action.action_type}</td>
                    <td style={{ padding: '12px' }}>
                      <span style={{
                        padding: '4px 8px',
                        borderRadius: '4px',
                        background: action.status === 'SUCCESS' ? '#4caf50' : 
                                   action.status === 'ERROR' ? '#f44336' : '#ff9800',
                        color: 'white',
                        fontSize: '12px'
                      }}>
                        {action.status}
                      </span>
                    </td>
                    <td style={{ padding: '12px' }}>{action.start_time}</td>
                    <td style={{ padding: '12px' }}>{action.duration_ms || 'In Progress'}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Error Logs Table */}
      <div style={{
        background: 'white',
        borderRadius: '10px',
        padding: '20px',
        marginBottom: '30px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <h3 style={{ marginTop: 0, marginBottom: '20px' }}>Recent Errors</h3>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: '#f5f5f5', borderBottom: '2px solid #ddd' }}>
                <th style={{ padding: '12px', textAlign: 'left' }}>ID</th>
                <th style={{ padding: '12px', textAlign: 'left' }}>Error Type</th>
                <th style={{ padding: '12px', textAlign: 'left' }}>Error Message</th>
                <th style={{ padding: '12px', textAlign: 'left' }}>Severity</th>
                <th style={{ padding: '12px', textAlign: 'left' }}>Time</th>
              </tr>
            </thead>
            <tbody>
              {kpiData.errorLogs.length === 0 ? (
                <tr>
                  <td colSpan="5" style={{ padding: '40px', textAlign: 'center', color: '#999' }}>
                    No errors logged yet.
                  </td>
                </tr>
              ) : (
                kpiData.errorLogs.map((error) => (
                  <tr key={error.id} style={{ borderBottom: '1px solid #eee' }}>
                    <td style={{ padding: '12px' }}>{error.id}</td>
                    <td style={{ padding: '12px' }}>{error.error_type}</td>
                    <td style={{ padding: '12px' }}>{error.error_message}</td>
                    <td style={{ padding: '12px' }}>
                      <span style={{
                        padding: '4px 8px',
                        borderRadius: '4px',
                        background: error.severity === 'HIGH' ? '#f44336' :
                                   error.severity === 'MEDIUM' ? '#ff9800' : '#4caf50',
                        color: 'white',
                        fontSize: '12px'
                      }}>
                        {error.severity}
                      </span>
                    </td>
                    <td style={{ padding: '12px' }}>{error.created_at}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* API Logs Table */}
      <div style={{
        background: 'white',
        borderRadius: '10px',
        padding: '20px',
        marginBottom: '30px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <h3 style={{ marginTop: 0, marginBottom: '20px' }}>API Calls Log</h3>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: '#f5f5f5', borderBottom: '2px solid #ddd' }}>
                <th style={{ padding: '12px', textAlign: 'left' }}>Service</th>
                <th style={{ padding: '12px', textAlign: 'left' }}>Endpoint</th>
                <th style={{ padding: '12px', textAlign: 'left' }}>Method</th>
                <th style={{ padding: '12px', textAlign: 'left' }}>Status Code</th>
                <th style={{ padding: '12px', textAlign: 'left' }}>Duration (ms)</th>
                <th style={{ padding: '12px', textAlign: 'left' }}>Time</th>
              </tr>
            </thead>
            <tbody>
              {kpiData.apiLogs.length === 0 ? (
                <tr>
                  <td colSpan="6" style={{ padding: '40px', textAlign: 'center', color: '#999' }}>
                    No API calls logged yet.
                  </td>
                </tr>
              ) : (
                kpiData.apiLogs.map((api) => (
                  <tr key={api.id} style={{ borderBottom: '1px solid #eee' }}>
                    <td style={{ padding: '12px' }}>{api.service_name}</td>
                    <td style={{ padding: '12px' }}>{api.endpoint}</td>
                    <td style={{ padding: '12px' }}>{api.method}</td>
                    <td style={{ padding: '12px' }}>
                      <span style={{
                        padding: '4px 8px',
                        borderRadius: '4px',
                        background: api.status_code >= 200 && api.status_code < 300 ? '#4caf50' :
                                   api.status_code >= 400 ? '#f44336' : '#ff9800',
                        color: 'white',
                        fontSize: '12px'
                      }}>
                        {api.status_code}
                      </span>
                    </td>
                    <td style={{ padding: '12px' }}>{api.duration_ms}</td>
                    <td style={{ padding: '12px' }}>{api.created_at}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Performance Logs Table */}
      <div style={{
        background: 'white',
        borderRadius: '10px',
        padding: '20px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <h3 style={{ marginTop: 0, marginBottom: '20px' }}>Performance Metrics</h3>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: '#f5f5f5', borderBottom: '2px solid #ddd' }}>
                <th style={{ padding: '12px', textAlign: 'left' }}>Service</th>
                <th style={{ padding: '12px', textAlign: 'left' }}>Operation</th>
                <th style={{ padding: '12px', textAlign: 'left' }}>Duration (ms)</th>
                <th style={{ padding: '12px', textAlign: 'left' }}>Status</th>
                <th style={{ padding: '12px', textAlign: 'left' }}>Time</th>
              </tr>
            </thead>
            <tbody>
              {kpiData.performanceLogs.length === 0 ? (
                <tr>
                  <td colSpan="5" style={{ padding: '40px', textAlign: 'center', color: '#999' }}>
                    No performance logs available.
                  </td>
                </tr>
              ) : (
                kpiData.performanceLogs.map((perf) => (
                  <tr key={perf.id} style={{ borderBottom: '1px solid #eee' }}>
                    <td style={{ padding: '12px' }}>{perf.service_name}</td>
                    <td style={{ padding: '12px' }}>{perf.operation}</td>
                    <td style={{ padding: '12px' }}>{perf.duration_ms}</td>
                    <td style={{ padding: '12px' }}>
                      <span style={{
                        padding: '4px 8px',
                        borderRadius: '4px',
                        background: perf.status === 'SUCCESS' ? '#4caf50' : '#f44336',
                        color: 'white',
                        fontSize: '12px'
                      }}>
                        {perf.status}
                      </span>
                    </td>
                    <td style={{ padding: '12px' }}>{perf.created_at}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Refresh Button */}
      <div style={{ position: 'fixed', bottom: '20px', right: '20px' }}>
        <button
          onClick={fetchDashboardData}
          disabled={loading}
          style={{
            background: '#2196f3',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            padding: '10px 20px',
            cursor: 'pointer',
            boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
          }}
        >
          {loading ? 'Refreshing...' : 'Refresh Data'}
        </button>
      </div>
    </div>
  );
};

export default KpiDashboard;